/* CUSTOM coffee-pair — 3 zufällige verfügbare Cups, Shuffle, Auswahl, dann Kaffee (Menge)
   + Cup zusammen in den Warenkorb (AJAX /cart/add.js). Preis rechnet live mit. */
(function () {
  if (customElements.get('coffee-pair')) return;

  class CoffeePair extends HTMLElement {
    connectedCallback() {
      this.pool = Array.prototype.map.call(
        this.querySelectorAll('.coffee-pair__item'),
        function (s) { try { return JSON.parse(s.textContent); } catch (e) { return null; } }
      ).filter(Boolean);
      this.cardsEl = this.querySelector('[data-cards]');
      this.shuffleBtn = this.querySelector('[data-shuffle]');
      this.addBtn = this.querySelector('[data-add]');
      this.coffeeVariant = Number(this.dataset.coffeeVariant);
      this.coffeePrice = parseInt(this.dataset.coffeePrice, 10) || 0;
      this.qtyInput = document.getElementById(this.dataset.qtyInput);
      this.selected = null;

      if (!this.pool.length) { this.style.display = 'none'; return; }
      this.shuffleBtn.addEventListener('click', this.shuffle.bind(this));
      this.addBtn.addEventListener('click', this.add.bind(this));
      if (this.qtyInput) this.qtyInput.addEventListener('change', this.updateAdd.bind(this));
      this.pick();
    }

    qty() { return Math.max(1, parseInt((this.qtyInput && this.qtyInput.value) || '1', 10)); }
    money(cents) {
      var v = cents / 100;
      var s = (v % 1 === 0) ? String(v) : v.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      return s + ' EUR';
    }

    pick() {
      var pool = this.pool.slice();
      for (var i = pool.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var t = pool[i]; pool[i] = pool[j]; pool[j] = t;
      }
      this.picks = pool.slice(0, 3);
      this.selected = null;
      this.render();
    }

    shuffle() {
      var self = this, cards = this.cardsEl;
      cards.classList.add('is-shuffling');
      setTimeout(function () { self.pick(); cards.classList.remove('is-shuffling'); }, 240);
    }

    render() {
      this.cardsEl.innerHTML = '';
      var self = this;
      this.picks.forEach(function (item) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'coffee-pair__card' + (self.selected && self.selected.id === item.id ? ' is-selected' : '');
        b.innerHTML =
          '<span class="coffee-pair__thumb">' +
            (item.img ? '<img src="' + item.img + '" alt="" loading="lazy">' : '') +
            '<span class="coffee-pair__code">' + item.title + '</span>' +
            (item.code ? '<span class="coffee-pair__sku">' + item.code + '</span>' : '') +
            '<span class="coffee-pair__price">' + self.money(item.price) + '</span>' +
          '</span>';
        b.addEventListener('click', function () { self.selected = item; self.render(); });
        self.cardsEl.appendChild(b);
      });
      this.updateAdd();
    }

    updateAdd() {
      if (this.selected) {
        this.addBtn.disabled = false;
        var total = this.coffeePrice * this.qty() + this.selected.price;
        this.addBtn.textContent = 'Add the pair to cart · ' + this.money(total);
      } else {
        this.addBtn.disabled = true;
        this.addBtn.textContent = 'Add the pair to cart';
      }
    }

    add() {
      if (!this.selected) return;
      this.addBtn.disabled = true;
      this.addBtn.textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [
          { id: this.coffeeVariant, quantity: this.qty() },
          { id: this.selected.id, quantity: 1 }
        ] })
      })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function () { window.location.href = '/cart'; })
        .catch(function () {
          this.addBtn.disabled = false;
          this.updateAdd();
        }.bind(this));
    }
  }

  customElements.define('coffee-pair', CoffeePair);
})();
